import { motion } from "framer-motion";
import { Briefcase, Camera, Laptop, Sparkles } from "lucide-react";
import { STATS } from "../../lib/data";

const ICONS = {
  years: Sparkles,
  briefcase: Briefcase,
  camera: Camera,
  laptop: Laptop,
};

export default function Stats() {
  return (
    <section
      data-testid="stats-section"
      className="relative border-t border-white/5 px-6 md:px-12 py-14 md:py-16"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8">
        {STATS.map((s, i) => {
          const Icon = ICONS[s.icon] || Sparkles;
          return (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              data-testid={`stat-${i}`}
              className="flex flex-col items-center text-center gap-3"
            >
              <Icon className="w-7 h-7 text-[#e63946]" aria-hidden />
              {s.value ? (
                <span className="font-display text-2xl text-white">{s.value}</span>
              ) : null}
              <span className="font-display uppercase text-sm md:text-base tracking-wide text-white">
                {s.title}
              </span>
              <span className="font-body text-xs md:text-sm text-white/50 leading-snug">
                {s.description}
              </span>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
